import { doDefaultFetch } from '@nhl/fetch-helpers';

const fetchPlayerTotalsData = args => {
    return doDefaultFetch(
        `/site/api/player/totals/` +
        `?cayenneExp=season = ${args.season} and gameType = ${args.gameType}` +
        `&include=points` +
        `&include=goals` +
        `&include=gamesPlayed` +
        `&include=season.id` +
        `&include=player.firstName` +
        `&include=player.lastName` +
        `&include=player.id` +
        `&include=player.sweaterNumber` +
        `&include=player.position.positionCode` +
        `&include=team.triCode` +
        `&include=team.logos`,
        args
    );
};

const fetchGoalieTotalsData = args => {
    return doDefaultFetch(
        `/site/api/goalie/totals/` +
        `?cayenneExp=season = ${args.season} and gameType = ${args.gameType}` +
        `&include=wins` +
        `&include=goalsAgainstAverage` +
        `&include=gamesPlayed` +
        `&include=savePercentage` +
        `&include=timeOnIce` +
        `&include=player.firstName` +
        `&include=player.lastName` +
        `&include=player.id` +
        `&include=player.sweaterNumber` +
        `&include=player.position.positionCode` +
        `&include=team.triCode` +
        `&include=team.logos` +
        `&include=season.id` +
        `&include=season.minimumPlayoffMinutesForGoalieStatsLeaders` +
        `&include=season.minimumRegularGamesForGoalieStatsLeaders`,
        args
    );
};

const getLeaders = (players, sortByProps, limit) => {
    if(players){
       return players.sort((a, b) => {
            let comparisonValue = 0;
            let sortByIndex = 0;

            while (comparisonValue === 0 && sortByIndex < sortByProps.length) {
                const sortPropertyInfo = sortByProps[sortByIndex];
                const { property, direction = 'DESC' } = sortPropertyInfo;
                if (property === 'player') {
                    comparisonValue = a[property].lastName.localeCompare(b[property].lastName);
                } else if (property === 'player.id') {
                    // If we add in more nested props later on we should look into using dotProps or something that
                    // can handle this situation better. For one case though I think this is fine
                    comparisonValue = a.player.id - b.player.id;
                } else {
                    comparisonValue = a[property] - b[property];
                }

                if (direction === 'DESC') {
                    comparisonValue *= -1;
                }

                sortByIndex++;
            }

            return comparisonValue;
        }).slice(0, limit);
    }
};

const getGAALeaders = (players, limit, gameType) => {
    if (players) {
        return getLeaders(players.filter(player => {
            if (gameType <= 2) {
                return player.gamesPlayed >=
                    player.season.minimumRegularGamesForGoalieStatsLeaders;
            } else {
                return player.timeOnIce / 60 >=
                    player.season.minimumPlayoffMinutesForGoalieStatsLeaders;
            }
        }), [
                    {property: 'goalsAgainstAverage', direction: 'ASC'},
                    {property: 'player.id', direction: 'ASC'}
            ], limit);
    }
};

export default {
    fetchPlayerTotalsData,
    fetchGoalieTotalsData,
    getLeaders,
    getGAALeaders
};
